import { media } from '@/styles/Qtheme';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const ItemWrapper = styled.div`
  width: 100%;
  border-radius: 30px;
  padding: 12px;
  border: 1px solid transparent;

  display: flex;
  flex-direction: column;

  &:hover {
    cursor: pointer;
  }

  &.expanded {
    border: 1px solid #353535;
  }
`;

export const ItemHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
  padding: 36px 60px;
  border-radius: 30px;
  width: 100%;

  font-family: 'Aggro', sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.02em;
  color: #ffffff;

  &.expanded {
    background: rgba(0, 110, 73, 0.08);
  }

  @media ${media.mobile} {
    font-size: 16px;
    padding: 20px 16px;
    border-radius: 24px;
  }
`;

export const IconWrapper = styled.div<{ size: number }>`
  width: 46px;
  height: 46px;
  border-radius: 10px;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.3s ease;
  background: rgba(0, 110, 73, 0.08);

  .expanded & {
    background: #07d993;
    box-shadow: 0px 12px 30px 0px rgba(7, 217, 147, 0.5);
  }

  svg {
    transition: transform 0.3s ease;
  }

  .expanded & svg {
    transform: rotate(180deg);
  }

  @media ${media.mobile} {
    width: 32px;
    height: 32px;
  }
`;

export const ItemContent = styled.div<{ isExpanded: boolean }>`
  max-height: ${({ isExpanded }) => (isExpanded ? 'auto' : '0')};
  opacity: ${({ isExpanded }) => (isExpanded ? '1' : '0')};
  overflow: hidden;
  transition:
    max-height 0.4s ease-in-out,
    opacity 0.3s ease-in-out;
  padding: 0 60px;

  @media ${media.mobile} {
    padding: 0 16px;
  }
`;
